import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import RoleControlled from '../../_common/RoleControlled'

import { toggleVisibility, showToast } from '../../../actions'
import { URL } from '../../../const'

import CategoryItem from './CategoryItem'
import AddCategory from './AddCategory'
import Loader from '../../_common/Loader'

export class Guides extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      loading: true,
      data: [],
      addingNewCategory: false,
      show_panel: false
    }
  }
  componentDidMount () {
    this._fetchData()
  }
  async _fetchData () {
    this.setState({ loading: true })
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`
      }
    }
    const url = `${URL}guides/categories/${this.props.propertyID}`
    try {
      const res = await axios.get(
        url,
        config
      )
      const data = res.data.items
      this.setState({ data, loading: false, show_panel: res.data.show })
    } catch (error) {
      console.log('An error occured while fetching this property guides data.')
    }
  }

  _handleAddClick () {
    console.log('add category')
    this.setState({ addingNewCategory: true })
  }
  _handleCancelClick () {
    console.log('cancel')
    this.setState({ addingNewCategory: false })
  }
  _handleEnablePanel (e) {
    this.setState({ show_panel: e.target.checked })
    this.props.toggleVisibility(this.props.propertyID, 0, e.target.checked)
  }

  async _handleSaveCategory (data, image) {
    console.log('saving data...', data)
    const url = `${URL}guides/categories/${this.props.propertyID}`
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`,
        'Content-Type': 'multipart/form-data'
      }
    }

    const formData = new FormData()
    formData.append('data', JSON.stringify(data))
    if (image) {
      const imageExtension = image.name.split('.').pop()
      const imageName = `guide-property${this.props.propertyID || '000'}-${Date.now()}.${imageExtension}`

      console.log('image: ', image)
      console.log('imageName: ', imageName)
      formData.append('image', image, imageName)
    }
    try {
      const res = await axios.post(
        url,
        formData,
        config
      )
      console.log('post res: ', res)
      this.props.showToast('保存しました！', 'primary')
      this._fetchData()
    } catch (error) {
      console.log('error: ', error)
      this.props.showToast('エラーが発生しました。', 'danger')
    }
  }
  async _handleCreateCategory (data, image) {
    console.log('saving data...', data)
    const url = `${URL}guides/categories/${this.props.propertyID}`
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`,
        'Content-Type': 'multipart/form-data'
      }
    }
    const formData = new FormData()
    formData.append('data', JSON.stringify(data))
    if (image) {
      const imageExtension = image.name.split('.').pop()
      const imageName = `guide-property${this.props.propertyID || '000'}-${Date.now()}.${imageExtension}`

      console.log('image: ', image)
      console.log('imageName: ', imageName)
      formData.append('image', image, imageName)
    }

    console.log('create data: ', JSON.stringify(data))
    try {
      const res = await axios.post(
        url,
        formData,
        config
      )
      console.log('post res: ', res)
      this.setState({ addingNewCategory: false })
      this.props.showToast('保存しました！', 'primary')
      this._fetchData()
    } catch (error) {
      console.log('error: ', error)
      this.props.showToast('エラーが発生しました。', 'danger')
    }
  }
  async _handleDeleteCategory (id) {
    const url = `${URL}guides/categories?id=${id}`
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`
      }
    }
    try {
      const res = await axios.delete(
        url,
        config
      )
      console.log('post res: ', res)
      this.props.showToast('削除しました。', 'danger')
      this._fetchData()
    } catch (error) {
      console.log('error: ', error)
    }
  }
  _renderMain () {
    return (
      <div className="inner_container">
        { this._renderAddItem() }
        { this._renderList() }
      </div>
    )
  }

  _renderAddItem () {
    if (this.state.addingNewCategory) {
      return <AddCategory saveData={this._handleCreateCategory.bind(this)} cancel={this._handleCancelClick.bind(this)}/>
    }
    return null
  }

  _renderList () {
    return this.state.data.map(item => {
      return (
        <CategoryItem
          propertyID={this.props.propertyID}
          category={item}
          key={item.id}
          role={this.props.user.user_role}
          saveData={this._handleSaveCategory.bind(this)}
          deleteData={this._handleDeleteCategory.bind(this)}
        />
      )
    })
  }
  _renderLoader () {
    if (this.state.loading) {
      return <Loader classname="loader_dot_circle small"/>
    }
    return null
  }
  render () {
    if (this.props.activeDetails.data.owner_id === 1) { return null }
    return (
      <div>
        <h4 className="page_title bold flex justify-between">
          <div className="title flex">
            <span>各種ご案内一覧　カテゴリ</span>
            { this._renderLoader() }
          </div>
          <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]}>
            <div className="switch">
              <input type="checkbox" id="showSwitch" className="switch-input" key="checkbox" onChange={this._handleEnablePanel.bind(this)} checked={this.state.show_panel}/>
              <label htmlFor="showSwitch" className="switch-label" key="label">
                <span className="toggle--on">表示</span>
                <span className="toggle--off">非表示</span>
              </label>
            </div>
          </RoleControlled>
        </h4>
        {
          this.state.show_panel
            ? (
              <div>
                <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]}>
                  <div className="add_btn_container flex">
                    <button className="btn primary small_btn flex align-center" onClick={this._handleAddClick.bind(this)}>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-add">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                      </svg>
                      <span>追加</span>
                    </button>
                  </div>
                </RoleControlled>

                <div className="list_container">
                  {
                    this.state.loading
                      ? <Loader classname="loader_dot_circle"/>
                      : this._renderMain()
                  }
                </div>
              </div>
            )
            : null
        }
      </div>
    )
  }
}

function mapStateToProps ({ user, activeDetails }) {
  return { user, activeDetails }
}

export default connect(mapStateToProps, { toggleVisibility, showToast })(Guides)



// WEBPACK FOOTER //
// ./src/components/Properties/Guides/index.js